import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye, MousePointerClick } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-147">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} data-id="element-148">
        <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-149">
          El mecanismo: <br data-id="element-150" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#25F4EE] to-[#FE2C55]" data-id="element-151">
            Hook → Prueba → Tag
          </span>
        </h2>

        <p className="text-lg text-gray-300 mb-10" data-id="element-152">
          La mayoría hace videos que "se ven lindos" y no venden. Aquí no. Cada
          video sigue una estructura que fuerza intención:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-153">
          {/* Hook */}
          <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/5 hover:border-[#25F4EE]/30 transition-colors" data-id="element-154">
            <div className="w-12 h-12 bg-[#25F4EE]/10 rounded-full flex items-center justify-center mb-4" data-id="element-155">
              <Target className="w-6 h-6 text-[#25F4EE]" data-id="element-156" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-157">Hook</h3>
            <p className="text-gray-400 text-sm" data-id="element-158">
              detiene el scroll en 2 segundos
            </p>
          </div>

          {/* Prueba */}
          <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/5 hover:border-white/20 transition-colors" data-id="element-159">
            <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mb-4" data-id="element-160">
              <Eye className="w-6 h-6 text-white" data-id="element-161" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-162">Prueba</h3>
            <p className="text-gray-400 text-sm" data-id="element-163">
              muestra algo real (no explicación eterna)
            </p>
          </div>

          {/* Tag */}
          <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/5 hover:border-[#FE2C55]/30 transition-colors" data-id="element-164">
            <div className="w-12 h-12 bg-[#FE2C55]/10 rounded-full flex items-center justify-center mb-4" data-id="element-165">
              <MousePointerClick className="w-6 h-6 text-[#FE2C55]" data-id="element-166" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-167">Tag</h3>
            <p className="text-gray-400 text-sm" data-id="element-168">pide el clic sin pena</p>
          </div>
        </div>

        <div className="bg-[#25F4EE]/5 border-l-4 border-[#25F4EE] p-6 rounded-r-xl" data-id="element-169">
          <p className="text-lg md:text-xl font-medium text-white italic" data-id="element-170">
            "Sin Tag, tu video es entretenimiento gratis. Con Tag, tu video se
            convierte en una acción."
          </p>
        </div>
      </motion.div>
    </section>;
}